/**
 * @generated SignedSource<<48830a402cd80f811969168230a9dd50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRange_filterValue$data = {
  readonly linkReference: string | null;
  readonly stats: ReadonlyArray<{
    readonly key: string | null;
    readonly values: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedRefineMenuInputRange_filterValue";
};
export type SbSharedRefineMenuInputRange_filterValue$key = {
  readonly " $data"?: SbSharedRefineMenuInputRange_filterValue$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRange_filterValue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRange_filterValue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "stats",
      "kind": "LinkedField",
      "name": "stats",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "values",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseFilterValue",
  "abstractKey": null
};

(node as any).hash = "c56c481d0026df64e75b4851c5b44417";

export default node;
